import { useEffect, useCallback } from "react";

export default function useTawkControl() {
  const hideWidget = useCallback(() => {
    if (window.Tawk_API?.hideWidget) {
      window.Tawk_API.hideWidget();
    }
  }, []);

  const showWidget = useCallback(() => {
    if (window.Tawk_API?.showWidget) {
      window.Tawk_API.showWidget();
    }
  }, []);

  const repositionWidget = useCallback((position = { xOffset: 20, yOffset: 100 }) => {
    if (window.Tawk_API?.customStyle) {
      window.Tawk_API.customStyle = {
        bottom: position.yOffset + "px",
        right: position.xOffset + "px",
      };
    }
  }, []);

  // Optional: delay until widget loads
  const onTawkLoad = useCallback((callback) => {
    if (window.Tawk_API) {
      window.Tawk_API.onLoad = callback;
    }
  }, []);

  return {
    hideWidget,
    showWidget,
    repositionWidget,
    onTawkLoad,
  };
}
